/******** Get User from store  ***********/
export const User = (store) => {
    return store.getState().user;
};

/******** Routing authentication middleware ***********/
export const Auth = (store) => {
    return User(store).loggedIn;
};
/******** Set Authorization token in header ***********/
export const setAuthorizationToken = (axios, token) => {
    let tokenLatest = getAccessToken('token')
    if (token) {
        axios.defaults.headers.common.Authorization = token || tokenLatest;
    } else {
        delete axios.defaults.headers.common.Authorization;
    }
};

/******** Set Access token from session ***********/
export const setAccessToken = (token) => {
    if (token) {
        sessionStorage.setItem('token', token);
    } else {
        sessionStorage.removeItem('token');
        localStorage.removeItem('token')
    }
};

/******** Get Access token from session ***********/
export const getAccessToken = () => {
    let sessionToken = sessionStorage.getItem('token');
    let localToken = localStorage.getItem('token')
    return sessionToken || localToken;
};
